/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
};

export type AddFoodToOfferInput = {
  canteenId: Scalars['Int']['input'];
  date: Scalars['DateTime']['input'];
  foodId: Scalars['Int']['input'];
};

export type Canteen = {
  __typename?: 'Canteen';
  canteenSystemType?: Maybe<CanteenSystemType>;
  city?: Maybe<Scalars['String']['output']>;
  externalSystemId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lastOfferUpdateAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  region?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export enum CanteenSystemType {
  Ejidelnicek = 'EJIDELNICEK',
  Estrava = 'ESTRAVA',
  Strava = 'STRAVA'
}

export type Comment = {
  __typename?: 'Comment';
  date: Scalars['DateTime']['output'];
  food?: Maybe<Food>;
  id: Scalars['Int']['output'];
  ratingPreparation?: Maybe<Scalars['Int']['output']>;
  ratingTaste?: Maybe<Scalars['Int']['output']>;
  ratingVisual?: Maybe<Scalars['Int']['output']>;
  text: Scalars['String']['output'];
  user?: Maybe<User>;
};

export type CreateCanteenInput = {
  canteenSystemType?: InputMaybe<CanteenSystemType>;
  city?: InputMaybe<Scalars['String']['input']>;
  externalSystemId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCommentInput = {
  foodId: Scalars['Int']['input'];
  ratingPreparation: Scalars['Int']['input'];
  ratingTaste: Scalars['Int']['input'];
  ratingVisual: Scalars['Int']['input'];
  text: Scalars['String']['input'];
};

export type CreateFoodInput = {
  canteenId: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type Food = {
  __typename?: 'Food';
  averageRating?: Maybe<Scalars['Float']['output']>;
  canteenId: Scalars['Int']['output'];
  comments?: Maybe<Array<Comment>>;
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  offer: Array<Offer>;
  photos?: Maybe<Array<Photo>>;
  rejectedConflictsWith: Array<Food>;
  similarNames?: Maybe<Array<FoodHasSimilarNames>>;
  tags: Array<Tag>;
  userId: Scalars['Int']['output'];
};

export type FoodHasSimilarNames = {
  __typename?: 'FoodHasSimilarNames';
  alternateName: Scalars['String']['output'];
  food: Food;
  id: Scalars['Int']['output'];
};

export type ForgotPasswordConfirmInput = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
  userId: Scalars['Float']['input'];
};

export type ForgotPasswordRequestInput = {
  email: Scalars['String']['input'];
};

export type GeneratedFood = {
  __typename?: 'GeneratedFood';
  ingredients: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  recipe: Scalars['String']['output'];
};

export type GetCanteensArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type GetCommentsArgs = {
  canteenId?: InputMaybe<Scalars['Int']['input']>;
  foodId?: InputMaybe<Scalars['Int']['input']>;
};

export type GetFoodsArgs = {
  canteenId?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GetOffersInput = {
  canteenId: Scalars['Int']['input'];
  from: Scalars['String']['input'];
  order?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
};

export type GetPhotosArgs = {
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  foodId?: InputMaybe<Scalars['Int']['input']>;
};

export type LoginInput = {
  email: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  token: Scalars['String']['output'];
  user: User;
};

export type Mutation = {
  __typename?: 'Mutation';
  addFoodToOffer: Offer;
  approvePhoto: Photo;
  createCanteen: Canteen;
  createComment: Comment;
  createFood: Food;
  forgotPasswordConfirm: Scalars['Boolean']['output'];
  forgotPasswordRequest: Scalars['Boolean']['output'];
  login: LoginResponse;
  logout: Scalars['Boolean']['output'];
  refreshCanteen: Scalars['Boolean']['output'];
  register: LoginResponse;
  rejectFoodConflict: Scalars['Int']['output'];
  removeCanteen: Scalars['Int']['output'];
  removeComment: Scalars['Int']['output'];
  removeFood: Scalars['Int']['output'];
  removeFoodFromOffer: Offer;
  removePhoto: Scalars['Boolean']['output'];
  removeUser: Scalars['Int']['output'];
  resolveFoodConflict: Food;
  updateCanteen: Canteen;
  updateFood: Food;
  updateUser: User;
  verifyAccountConfirm: Scalars['Boolean']['output'];
  verifyAccountRequest: Scalars['Boolean']['output'];
};


export type MutationAddFoodToOfferArgs = {
  data: AddFoodToOfferInput;
};


export type MutationApprovePhotoArgs = {
  id: Scalars['Int']['input'];
};


export type MutationCreateCanteenArgs = {
  data: CreateCanteenInput;
};


export type MutationCreateCommentArgs = {
  data: CreateCommentInput;
};


export type MutationCreateFoodArgs = {
  data: CreateFoodInput;
};


export type MutationForgotPasswordConfirmArgs = {
  data: ForgotPasswordConfirmInput;
};


export type MutationForgotPasswordRequestArgs = {
  data: ForgotPasswordRequestInput;
};


export type MutationLoginArgs = {
  data: LoginInput;
};


export type MutationRefreshCanteenArgs = {
  canteenId: Scalars['Int']['input'];
};


export type MutationRegisterArgs = {
  data: RegisterInput;
};


export type MutationRejectFoodConflictArgs = {
  data: RejectFoodConflictInput;
};


export type MutationRemoveCanteenArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveCommentArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveFoodArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveFoodFromOfferArgs = {
  data: RemoveFoodFromInput;
};


export type MutationRemovePhotoArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveUserArgs = {
  id: Scalars['Int']['input'];
};


export type MutationResolveFoodConflictArgs = {
  data: ResolveFoodConflictInput;
};


export type MutationUpdateCanteenArgs = {
  data: UpdateCanteenInput;
};


export type MutationUpdateFoodArgs = {
  data: UpdateFoodInput;
};


export type MutationUpdateUserArgs = {
  data: UpdateUserInput;
};


export type MutationVerifyAccountConfirmArgs = {
  data: VerifyAccountConfirmInput;
};


export type MutationVerifyAccountRequestArgs = {
  data: VerifyAccountRequestInput;
};

export type Offer = {
  __typename?: 'Offer';
  canteenId: Scalars['Int']['output'];
  date: Scalars['String']['output'];
  food: Array<Food>;
  id: Scalars['Int']['output'];
};

export type Photo = {
  __typename?: 'Photo';
  approved: Scalars['Boolean']['output'];
  food?: Maybe<Food>;
  id: Scalars['Int']['output'];
  s3url: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
};

export type Query = {
  __typename?: 'Query';
  canteen: Canteen;
  canteenOffers: Array<Offer>;
  canteens: Array<Canteen>;
  comments: Array<Comment>;
  food: Food;
  foods: Array<Food>;
  foodsConflicts: Array<Array<Food>>;
  generateMonthOffers: Array<Offer>;
  generateNewFood: GeneratedFood;
  photos: Array<Photo>;
  user: User;
  users: Array<User>;
};


export type QueryCanteenArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCanteenOffersArgs = {
  query: GetOffersInput;
};


export type QueryCanteensArgs = {
  query: GetCanteensArgs;
};


export type QueryCommentsArgs = {
  query: GetCommentsArgs;
};


export type QueryFoodArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFoodsArgs = {
  query: GetFoodsArgs;
};


export type QueryFoodsConflictsArgs = {
  canteenId: Scalars['Int']['input'];
};


export type QueryGenerateMonthOffersArgs = {
  canteenId: Scalars['Int']['input'];
  date: Scalars['DateTime']['input'];
};


export type QueryGenerateNewFoodArgs = {
  tags: Array<Scalars['String']['input']>;
};


export type QueryPhotosArgs = {
  query: GetPhotosArgs;
};


export type QueryUserArgs = {
  id: Scalars['Int']['input'];
};

export type RegisterInput = {
  canteenId: Scalars['Int']['input'];
  email: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  userName: Scalars['String']['input'];
};

export type RejectFoodConflictInput = {
  foodAId: Scalars['Int']['input'];
  foodBId: Scalars['Int']['input'];
};

export type RemoveFoodFromInput = {
  foodId: Scalars['Int']['input'];
  offerId: Scalars['Int']['input'];
};

export type ResolveFoodConflictInput = {
  foodToDeleteId: Scalars['Int']['input'];
  foodToKeepId: Scalars['Int']['input'];
  newDescription: Scalars['String']['input'];
  newName: Scalars['String']['input'];
};

export type Tag = {
  __typename?: 'Tag';
  name: Scalars['String']['output'];
  quantificator: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
};

export type UpdateCanteenInput = {
  canteenSystemType?: InputMaybe<CanteenSystemType>;
  city?: InputMaybe<Scalars['String']['input']>;
  externalSystemId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFoodInput = {
  canteenId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserInput = {
  adminLevel?: InputMaybe<Scalars['Int']['input']>;
  canteenId?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  isEmailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename?: 'User';
  adminLevel: Scalars['Int']['output'];
  canteen?: Maybe<Canteen>;
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isEmailVerified: Scalars['Boolean']['output'];
  userName: Scalars['String']['output'];
};

export type VerifyAccountConfirmInput = {
  token: Scalars['String']['input'];
  userId: Scalars['Float']['input'];
};

export type VerifyAccountRequestInput = {
  userId: Scalars['Float']['input'];
};

export type CreateCanteenMutationVariables = Exact<{
  data: CreateCanteenInput;
}>;


export type CreateCanteenMutation = { __typename?: 'Mutation', createCanteen: { __typename?: 'Canteen', id: number } };

export type AddFoodToOfferMutationVariables = Exact<{
  data: AddFoodToOfferInput;
}>;


export type AddFoodToOfferMutation = { __typename?: 'Mutation', addFoodToOffer: { __typename?: 'Offer', id: number } };

export type AddFoodMutationVariables = Exact<{
  data: CreateFoodInput;
}>;


export type AddFoodMutation = { __typename?: 'Mutation', createFood: { __typename?: 'Food', id: number } };

export type ApprovePhotoMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ApprovePhotoMutation = { __typename?: 'Mutation', approvePhoto: { __typename?: 'Photo', id: number } };

export type CreateCommentMutationVariables = Exact<{
  data: CreateCommentInput;
}>;


export type CreateCommentMutation = { __typename?: 'Mutation', createComment: { __typename?: 'Comment', id: number } };

export type UpdateCanteenMutationVariables = Exact<{
  data: UpdateCanteenInput;
}>;


export type UpdateCanteenMutation = { __typename?: 'Mutation', updateCanteen: { __typename?: 'Canteen', id: number } };

export type UpdateFoodMutationVariables = Exact<{
  data: UpdateFoodInput;
}>;


export type UpdateFoodMutation = { __typename?: 'Mutation', updateFood: { __typename?: 'Food', id: number } };

export type UpdateUserMutationVariables = Exact<{
  data: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: number } };

export type ForgotPasswordConfirmMutationVariables = Exact<{
  data: ForgotPasswordConfirmInput;
}>;


export type ForgotPasswordConfirmMutation = { __typename?: 'Mutation', forgotPasswordConfirm: boolean };

export type ForgotPasswordRequestMutationVariables = Exact<{
  data: ForgotPasswordRequestInput;
}>;


export type ForgotPasswordRequestMutation = { __typename?: 'Mutation', forgotPasswordRequest: boolean };

export type LoginMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'LoginResponse', token: string, user: { __typename?: 'User', id: number, email: string, userName: string, adminLevel: number, canteen?: { __typename?: 'Canteen', id: number } | null } } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: boolean };

export type RefreshCanteenMutationVariables = Exact<{
  canteenId: Scalars['Int']['input'];
}>;


export type RefreshCanteenMutation = { __typename?: 'Mutation', refreshCanteen: boolean };

export type RegisterMutationVariables = Exact<{
  data: RegisterInput;
}>;


export type RegisterMutation = { __typename?: 'Mutation', register: { __typename?: 'LoginResponse', token: string, user: { __typename?: 'User', id: number, email: string, userName: string, adminLevel: number, canteen?: { __typename?: 'Canteen', id: number } | null } } };

export type RejectFoodConflictMutationVariables = Exact<{
  data: RejectFoodConflictInput;
}>;


export type RejectFoodConflictMutation = { __typename?: 'Mutation', rejectFoodConflict: number };

export type RemoveCanteenMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RemoveCanteenMutation = { __typename?: 'Mutation', removeCanteen: number };

export type RemoveCommentMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RemoveCommentMutation = { __typename?: 'Mutation', removeComment: number };

export type RemoveFoodMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RemoveFoodMutation = { __typename?: 'Mutation', removeFood: number };

export type RemoveFoodFromOfferMutationVariables = Exact<{
  data: RemoveFoodFromInput;
}>;


export type RemoveFoodFromOfferMutation = { __typename?: 'Mutation', removeFoodFromOffer: { __typename?: 'Offer', id: number } };

export type RemovePhotoMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RemovePhotoMutation = { __typename?: 'Mutation', removePhoto: boolean };

export type RemoveUserMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RemoveUserMutation = { __typename?: 'Mutation', removeUser: number };

export type ResolveFoodConflictMutationVariables = Exact<{
  data: ResolveFoodConflictInput;
}>;


export type ResolveFoodConflictMutation = { __typename?: 'Mutation', resolveFoodConflict: { __typename?: 'Food', id: number } };

export type VerifyAccountConfirmMutationVariables = Exact<{
  data: VerifyAccountConfirmInput;
}>;


export type VerifyAccountConfirmMutation = { __typename?: 'Mutation', verifyAccountConfirm: boolean };

export type VerifyAccountRequestMutationVariables = Exact<{
  data: VerifyAccountRequestInput;
}>;


export type VerifyAccountRequestMutation = { __typename?: 'Mutation', verifyAccountRequest: boolean };

export type CanteenQueryQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type CanteenQueryQuery = { __typename?: 'Query', canteen: { __typename?: 'Canteen', id: number, name: string, region?: string | null, city?: string | null, slug?: string | null, canteenSystemType?: CanteenSystemType | null, externalSystemId?: string | null, lastOfferUpdateAt?: any | null } };

export type CanteenOffersQueryQueryVariables = Exact<{
  query: GetOffersInput;
}>;


export type CanteenOffersQueryQuery = { __typename?: 'Query', canteenOffers: Array<{ __typename?: 'Offer', id: number, date: string, food: Array<{ __typename?: 'Food', id: number, name: string, averageRating?: number | null }> }> };

export type CanteensQueryQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CanteensQueryQuery = { __typename?: 'Query', canteens: Array<{ __typename?: 'Canteen', id: number, name: string, region?: string | null, city?: string | null, canteenSystemType?: CanteenSystemType | null, externalSystemId?: string | null }> };

export type CommentsQueryQueryVariables = Exact<{
  query: GetCommentsArgs;
}>;


export type CommentsQueryQuery = { __typename?: 'Query', comments: Array<{ __typename?: 'Comment', id: number, text: string, date: any, ratingTaste?: number | null, ratingVisual?: number | null, ratingPreparation?: number | null, food?: { __typename?: 'Food', id: number, name: string } | null, user?: { __typename?: 'User', userName: string } | null }> };

export type FoodQueryQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type FoodQueryQuery = { __typename?: 'Query', food: { __typename?: 'Food', id: number, name: string, description: string, canteenId: number, averageRating?: number | null, similarNames?: Array<{ __typename?: 'FoodHasSimilarNames', alternateName: string }> | null, photos?: Array<{ __typename?: 'Photo', id: number, s3url: string }> | null } };

export type FoodsQueryQueryVariables = Exact<{
  canteenId: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type FoodsQueryQuery = { __typename?: 'Query', foods: Array<{ __typename?: 'Food', id: number, name: string, photos?: Array<{ __typename?: 'Photo', id: number, s3url: string }> | null }> };

export type FoodsConflictsQueryQueryVariables = Exact<{
  canteenId: Scalars['Int']['input'];
}>;


export type FoodsConflictsQueryQuery = { __typename?: 'Query', foodsConflicts: Array<Array<{ __typename?: 'Food', id: number, name: string, description: string, photos?: Array<{ __typename?: 'Photo', id: number, s3url: string }> | null }>> };

export type GenerateNewFoodQueryQueryVariables = Exact<{
  tags: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GenerateNewFoodQueryQuery = { __typename?: 'Query', generateNewFood: { __typename?: 'GeneratedFood', ingredients: Array<string>, name: string, recipe: string } };

export type GenerateMonthOffersQueryQueryVariables = Exact<{
  canteenId: Scalars['Int']['input'];
  date: Scalars['DateTime']['input'];
}>;


export type GenerateMonthOffersQueryQuery = { __typename?: 'Query', generateMonthOffers: Array<{ __typename?: 'Offer', id: number, date: string, canteenId: number, food: Array<{ __typename?: 'Food', canteenId: number, id: number, name: string, tags: Array<{ __typename?: 'Tag', name: string }> }> }> };

export type PhotosQueryQueryVariables = Exact<{
  foodId?: InputMaybe<Scalars['Int']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PhotosQueryQuery = { __typename?: 'Query', photos: Array<{ __typename?: 'Photo', id: number, s3url: string, food?: { __typename?: 'Food', id: number, name: string } | null }> };

export type UserQueryQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type UserQueryQuery = { __typename?: 'Query', user: { __typename?: 'User', id: number, userName: string, email: string, isEmailVerified: boolean, adminLevel: number, canteen?: { __typename?: 'Canteen', id: number } | null } };

export type UsersQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type UsersQueryQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', id: number, email: string, isEmailVerified: boolean, adminLevel: number, userName: string, canteen?: { __typename?: 'Canteen', id: number, name: string } | null }> };


export const CreateCanteenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createCanteen"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCanteenInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCanteen"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateCanteenMutation, CreateCanteenMutationVariables>;
export const AddFoodToOfferDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addFoodToOffer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddFoodToOfferInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addFoodToOffer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AddFoodToOfferMutation, AddFoodToOfferMutationVariables>;
export const AddFoodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addFood"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateFoodInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFood"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AddFoodMutation, AddFoodMutationVariables>;
export const ApprovePhotoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"approvePhoto"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approvePhoto"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ApprovePhotoMutation, ApprovePhotoMutationVariables>;
export const CreateCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCommentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createComment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateCommentMutation, CreateCommentMutationVariables>;
export const UpdateCanteenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCanteen"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCanteenInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCanteen"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateCanteenMutation, UpdateCanteenMutationVariables>;
export const UpdateFoodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateFood"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateFoodInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateFood"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateFoodMutation, UpdateFoodMutationVariables>;
export const UpdateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>;
export const ForgotPasswordConfirmDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"forgotPasswordConfirm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ForgotPasswordConfirmInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"forgotPasswordConfirm"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]} as unknown as DocumentNode<ForgotPasswordConfirmMutation, ForgotPasswordConfirmMutationVariables>;
export const ForgotPasswordRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"forgotPasswordRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ForgotPasswordRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"forgotPasswordRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]} as unknown as DocumentNode<ForgotPasswordRequestMutation, ForgotPasswordRequestMutationVariables>;
export const LoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"login"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"login"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"adminLevel"}},{"kind":"Field","name":{"kind":"Name","value":"canteen"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<LoginMutation, LoginMutationVariables>;
export const LogoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"logout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logout"}}]}}]} as unknown as DocumentNode<LogoutMutation, LogoutMutationVariables>;
export const RefreshCanteenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"refreshCanteen"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"canteenId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refreshCanteen"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"canteenId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"canteenId"}}}]}]}}]} as unknown as DocumentNode<RefreshCanteenMutation, RefreshCanteenMutationVariables>;
export const RegisterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"register"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RegisterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"register"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"adminLevel"}},{"kind":"Field","name":{"kind":"Name","value":"canteen"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RegisterMutation, RegisterMutationVariables>;
export const RejectFoodConflictDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"rejectFoodConflict"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RejectFoodConflictInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rejectFoodConflict"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]} as unknown as DocumentNode<RejectFoodConflictMutation, RejectFoodConflictMutationVariables>;
export const RemoveCanteenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeCanteen"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeCanteen"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<RemoveCanteenMutation, RemoveCanteenMutationVariables>;
export const RemoveCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeComment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<RemoveCommentMutation, RemoveCommentMutationVariables>;
export const RemoveFoodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeFood"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeFood"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<RemoveFoodMutation, RemoveFoodMutationVariables>;
export const RemoveFoodFromOfferDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeFoodFromOffer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveFoodFromInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeFoodFromOffer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveFoodFromOfferMutation, RemoveFoodFromOfferMutationVariables>;
export const RemovePhotoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removePhoto"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removePhoto"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<RemovePhotoMutation, RemovePhotoMutationVariables>;
export const RemoveUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<RemoveUserMutation, RemoveUserMutationVariables>;
export const ResolveFoodConflictDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"resolveFoodConflict"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResolveFoodConflictInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resolveFoodConflict"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ResolveFoodConflictMutation, ResolveFoodConflictMutationVariables>;
export const VerifyAccountConfirmDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"verifyAccountConfirm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VerifyAccountConfirmInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verifyAccountConfirm"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]} as unknown as DocumentNode<VerifyAccountConfirmMutation, VerifyAccountConfirmMutationVariables>;
export const VerifyAccountRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"verifyAccountRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VerifyAccountRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verifyAccountRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]} as unknown as DocumentNode<VerifyAccountRequestMutation, VerifyAccountRequestMutationVariables>;
export const CanteenQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"canteenQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canteen"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"canteenSystemType"}},{"kind":"Field","name":{"kind":"Name","value":"externalSystemId"}},{"kind":"Field","name":{"kind":"Name","value":"lastOfferUpdateAt"}}]}}]}}]} as unknown as DocumentNode<CanteenQueryQuery, CanteenQueryQueryVariables>;
export const CanteenOffersQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"canteenOffersQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetOffersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canteenOffers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"food"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"averageRating"}}]}}]}}]}}]} as unknown as DocumentNode<CanteenOffersQueryQuery, CanteenOffersQueryQueryVariables>;
export const CanteensQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"canteensQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canteens"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"canteenSystemType"}},{"kind":"Field","name":{"kind":"Name","value":"externalSystemId"}}]}}]}}]} as unknown as DocumentNode<CanteensQueryQuery, CanteensQueryQueryVariables>;
export const CommentsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"commentsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetCommentsArgs"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"ratingTaste"}},{"kind":"Field","name":{"kind":"Name","value":"ratingVisual"}},{"kind":"Field","name":{"kind":"Name","value":"ratingPreparation"}},{"kind":"Field","name":{"kind":"Name","value":"food"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userName"}}]}}]}}]}}]} as unknown as DocumentNode<CommentsQueryQuery, CommentsQueryQueryVariables>;
export const FoodQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"foodQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"food"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"canteenId"}},{"kind":"Field","name":{"kind":"Name","value":"averageRating"}},{"kind":"Field","name":{"kind":"Name","value":"similarNames"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alternateName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"photos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"s3url"}}]}}]}}]}}]} as unknown as DocumentNode<FoodQueryQuery, FoodQueryQueryVariables>;
export const FoodsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"foodsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"canteenId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"foods"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"canteenId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"canteenId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"photos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"s3url"}}]}}]}}]}}]} as unknown as DocumentNode<FoodsQueryQuery, FoodsQueryQueryVariables>;
export const FoodsConflictsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"foodsConflictsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"canteenId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"foodsConflicts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"canteenId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"canteenId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"photos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"s3url"}}]}}]}}]}}]} as unknown as DocumentNode<FoodsConflictsQueryQuery, FoodsConflictsQueryQueryVariables>;
export const GenerateNewFoodQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"generateNewFoodQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tags"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateNewFood"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tags"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tags"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ingredients"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"recipe"}}]}}]}}]} as unknown as DocumentNode<GenerateNewFoodQueryQuery, GenerateNewFoodQueryQueryVariables>;
export const GenerateMonthOffersQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"generateMonthOffersQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"canteenId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateMonthOffers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"canteenId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"canteenId"}}},{"kind":"Argument","name":{"kind":"Name","value":"date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"canteenId"}},{"kind":"Field","name":{"kind":"Name","value":"food"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canteenId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GenerateMonthOffersQueryQuery, GenerateMonthOffersQueryQueryVariables>;
export const PhotosQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"photosQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"foodId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"approved"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"foodId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"foodId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"approved"},"value":{"kind":"Variable","name":{"kind":"Name","value":"approved"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"s3url"}},{"kind":"Field","name":{"kind":"Name","value":"food"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<PhotosQueryQuery, PhotosQueryQueryVariables>;
export const UserQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"isEmailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"adminLevel"}},{"kind":"Field","name":{"kind":"Name","value":"canteen"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UserQueryQuery, UserQueryQueryVariables>;
export const UsersQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"usersQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"isEmailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"adminLevel"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"canteen"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<UsersQueryQuery, UsersQueryQueryVariables>;